import { render, staticRenderFns } from "./ProjetsComponent.vue?vue&type=template&id=fead84d4&scoped=true&"
import script from "./ProjetsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjetsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjetsComponent.vue?vue&type=style&index=0&id=fead84d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead84d4",
  null
  
)

export default component.exports